import { FC, useContext } from 'react';

import { layoutContext } from '@context/layout';

import { BlinqLogo } from '@components/BlinqAssets';
import { ToggleCollapseButton } from './ToggleCollapseButton';

import styles from './NavHeaderTopSection.module.scss';
import { AnimatePresence, motion } from 'motion/react';

const NavHeaderTopSection: FC<React.PropsWithChildren<unknown>> = () => {
  const { state: navState } = useContext(layoutContext);

  return (
    <div className={styles['nav-top-section']}>
      <AnimatePresence initial={false}>
        {!navState.collapsed && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: {
                delay: 0.2,
                duration: 0.2,
              },
            }}
            exit={{
              opacity: 0,
              transition: {
                duration: 0.1,
              },
            }}
            className={styles['blinq-brand-container']}
          >
            <BlinqLogo className={styles['blinq-logo']} />
          </motion.div>
        )}
      </AnimatePresence>

      <ToggleCollapseButton />
    </div>
  );
};

export { NavHeaderTopSection };
